/**
 * SIC code label helpers.
 *
 * Translations are keyed as `SicCode.<code>` (e.g. `SicCode.9811`). Some
 * locales ship the numeric code inside the label ("9811 - Citi pakalpojumi"),
 * others only the description ("Other services (non-profit)"). Select lists
 * must always show the code, so we prefix it ourselves when it is missing.
 */

/** Extracts `9811` from a `SicCode.9811` taxonomy code. */
export const getSicCodeNumber = (taxonomyCode?: string | null): string =>
  String(taxonomyCode ?? "").split(".")[1] ?? "";

/**
 * Builds the display label for a SIC code option: `<code> - <description>`.
 * Idempotent - labels that already start with the code are left untouched.
 */
export const formatSicCodeLabel = (
  taxonomyCode?: string | null,
  label?: string | null
): string => {
  const code = getSicCodeNumber(taxonomyCode);
  const text = String(label ?? "").trim();

  if (!code) return text;
  if (!text || text === taxonomyCode) return code;
  if (text.startsWith(code)) return text;

  return `${code} - ${text}`;
};
